export const dateFromObjectId = (id: String) => {
  if (id) {
    const timestamp = id.toString().substring(0, 8);
    return new Date(parseInt(timestamp, 16) * 1000);
  }
  return '';
};
